import { api } from 'components/api'
import { inboxConversationMessagesPath } from 'components/routes/api'
import type { ApiInboxMessage, InboxMessage } from '../inboxTypes'
import { mapApiMessageToInboxMessage } from '../inboxTypes'

interface ApiInboxMessageCreateResponse {
  message?: ApiInboxMessage
}

interface ApiInboxMessageCreateRequest {
  inbox_message: {
    content: string
  }
}

export const createInboxMessage = async (
  conversationId: number,
  content: string
): Promise<InboxMessage> => {
  const response = await api.postWithCsrf<
  ApiInboxMessageCreateRequest,
  ApiInboxMessageCreateResponse
  >({
    url: inboxConversationMessagesPath(conversationId),
    headers: { Accept: 'application/json' },
    data: {
      inbox_message: { content }
    }
  })

  if (response.data.message == null) {
    throw new Error('Inbox message create response is missing message')
  }

  return mapApiMessageToInboxMessage(response.data.message, conversationId)
}
